/* eslint-disable no-unused-expressions */
import React from 'react';
import './MyControlDone.css';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import * as httpService from '../HttpService/HttpService';
import {Documents} from '../documents';
import {ControlDto} from '../Dtos/ControlDto';
import {
	getPostControlDocType,
	getTablePageBaseOnControlNumber,
	getTablePageBaseOnPageNumber,
} from '../../Helpers/utils';
import {UploadDocumentsPopup} from '../UploadDocumentsPopup/UploadDocumentsPopup';
import {RemarksPopup} from '../Remarks/RemarksDetail';
import SelectCustom from '../SelectCustom/SelectCustom';
import Input from '../Input/Input';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {endsControlWithAfterControlNote, getPostControlDocuments} from "../documents/helpers";
import {TableCustomTabs} from "../TableCustom/TableCustomTabs";
import {cloneDeep} from "lodash";
import Checkbox from '@mui/material/Checkbox';
import {ControlResult, ControlResultLabels} from "../../enums/controlResult";

export const GET_CONTROL_DATA_REQUESTED = 'GET_CONTROL_DATA_REQUESTED';
export const GET_CONTROL_DATA_DONE = 'GET_CONTROL_DATA_DONE';
export const GET_CONTROL_DATA_FAILED = 'GET_CONTROL_DATA_FAILED';

const tabs = ['Zrealizowane', 'Zakończone'];

class MyControlDone extends React.Component {

	columnsDefault = [
		{title: 'Zakończone', field: 'completed', sorting: false, filtering: false, cellStyle: {textAlign: 'center'} },
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Data rozpoczęcia kontroli', field: 'dateStart', width: 80, cellStyle: {textAlign: 'center'}},//term
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120, className: 'beneficiary'},
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130},
		{title: 'Zalecenia', field: 'followUpString', width: 90},//followUpString
		{title: 'Wdrożenie zaleceń', field: 'followUpStatus', width: 90},//followUpStatus
		{title: 'Data wysłania informacji ostatecznej', field: 'finalInfoSentDate', width: 90}//postControlInfoFinalIssueDate
	];
	previousInputFocusId = null;

	getColumnsForTab = (tab) => {
		const columns = cloneDeep(this.columnsDefault);
		if (tab === tabs[1]) {
			columns.push({title: 'Wynik kontroli', field: 'internalControlResult', width: 120});
		}
		return columns;
	};

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			showDocumentsControl: null,
			isUploadDocsWindowVisible: false,
			showRemarksDetail: false,
			selectedTab: tabs[0],
			tabs: tabs.reduce((accumulator, value) => {
				return {...accumulator, [value]: {
					tablePageSize: 10,
					page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
					programSearch: "",
					quickSearch: "",
					filters: [],
					orderBy: "number",
					orderById: "",
					orderDirection: "asc",
				}};
			  }, {}),
			filterChangeOnField: null,
			columns: this.getColumnsForTab(tabs[0]),
			documentTitle: 'e-Kontrole | Moje kontrole zrealizowane',
			selectedControlResult: null,
			controlToComplete: null
		};
		this.followUpStatusSelectRef = React.createRef();
		this.programmsLoadedSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.restoreControl = this.restoreControl.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Moje kontrole zrealizowane";
		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableTab && this.props.controls.tableName === document.title) {
			newState.selectedTab = this.props.controls.tableTab;
		}
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters(newState.selectedTab);
			newState.tabs[newState.selectedTab].filters = this.props.controls.tableFilters;
		} else {
			newState.columns = this.getColumnsForTab(newState.selectedTab);
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.tabs[newState.selectedTab].quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.tabs[newState.selectedTab].page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.tabs[tabs[0]].programSearch = [store.getState().programs.selected];
			newState.tabs[tabs[1]].programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);
		fetchControlData(newState.tabs[newState.selectedTab].page, ControlFunctions.getFilterParam(newState.tabs[newState.selectedTab].filters), [newState.tabs[newState.selectedTab].orderBy, newState.tabs[newState.selectedTab].orderDirection], newState.tabs[newState.selectedTab].programSearch, newState.tabs[newState.selectedTab].quickSearch, newState.tabs[newState.selectedTab].tablePageSize, newState.selectedTab === tabs[1], (e) => this.handleRedirect(e));
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.tabs[this.state.selectedTab].page) {
			const newState = cloneDeep(this.state);
			newState.tabs[this.state.selectedTab].page = 0;
			this.setState(newState);
			this.props.history.push('/my_controls/done');
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);
		}
	}

	getDefaultFilters = (tab) => {
		const columns = this.getColumnsForTab(tab);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	setValues = (values) => {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[tabs[0]].programSearch = values;
		newState.tabs[tabs[1]].programSearch = values;
		this.setState(newState);
		
		this.props.history.push('/my_controls/done');
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], values, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);

	};

	handleClosePopUp() {
		this.setState({showPopup: false, selectedControlResult: null});
	}

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent, size) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent, size: size}
		})

	};

	setFollowUpStatus = (values) => {
		this.setState({
			followUpStatus: values[0]
		})
	};

	handleSaveFollowUp = (row) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let controlId = row.id;
		let url = PropertyBucket.getChangeFollowUpStatusInfo(controlId);
		let controlDto = new ControlDto();
		controlDto.controlId = controlId;
		controlDto.followUpStatus = this.state.followUpStatus.number;
		controlDto.followUpNote = document.querySelector('#editWindowTab #followUpNote').value;

		let callPromise = httpService.getServicePromise(url, 'PUT', controlDto);

		callPromise.then(
			function (message) {
				_this.props.fetchControlData(_this.state.tabs[_this.state.selectedTab].page, ControlFunctions.getFilterParam(_this.state.tabs[_this.state.selectedTab].filters), [_this.state.tabs[_this.state.selectedTab].orderBy, _this.state.tabs[_this.state.selectedTab].orderDirection], _this.state.tabs[_this.state.selectedTab].programSearch, _this.state.tabs[_this.state.selectedTab].quickSearch, _this.state.tabs[_this.state.selectedTab].tablePageSize, _this.state.selectedTab === tabs[1]);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.saveFollowUpStatusInfoMessage(), 'notify', null, 1)
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	displayFollowUpStatusSelect = (currentValue) => {
		let statusList = [{name: 'W trakcie wdrażania', number: 1}, {
			name: 'Wdrożono',
			number: 2
		}, {name: 'Częściowo wdrożono', number: 3}, {name: 'Nie wdrożono', number: 4}];
		let currentValues = statusList.filter(option => option.name === currentValue);

		this.setState({
			followUpStatus: currentValues[0]
		});

		return <div>
			<div id='follow_up_select'>
				<SelectCustom
					values={statusList.filter(option => option.name === currentValue)}
					labelField='name'
					placeholder='Status wdrażania zaleceń'
					valueField='name'
					options={statusList}
					onChange={(values) => this.setFollowUpStatus(values)}
					id='followUpStatusSelectId'
					dropdownId='followUpStatusDropdownId'
					label='Status wdrażania zaleceń'
					labelClassName='mt-3 font-weight-bold'
					parentRef={this.followUpStatusSelectRef}
				/>
			</div>
		</div>;
	};

	displayFollowUpTab = (row) => {
		let followUpWindow;
		followUpWindow = <div id='editWindowTab'><h5>Dotyczy kontroli {row.number}</h5>
			<div>
				{this.displayFollowUpStatusSelect(row.followUpStatus)}
				<Input
					textareaNative
					containerClassName='input-group'
					className='editFields'
					label='Notatka nt. stanu wdrażania zaleceń'
					labelClassName='mt-3 font-weight-bold'
					inputId='followUpNote'
					rows='5'
					defaultValue={row.followUpNote}
				/>
			</div>
			<div className='btn_group mb-2'>
				<button className='btn save-btn' id='save_button' onClick={() => this.handleSaveFollowUp(row)}>ZAPISZ</button>
				<button className='btn cancel-btn' onClick={() => this.handleClosePopUp()}>ANULUJ</button>
			</div>
		</div>;
		return followUpWindow;
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/my_controls/control_detail/' + row.id);
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/my_controls/control_list_detail/' + row.id);
	};

	onPostControlInfoRedirect = (row) => {
		this.props.history.push('/controls/post_control_info_detail/' + row.postControlDocuments[0].postControlInfo.infoId);
	};

	onPostControlNoteRedirect = (row) => {
		this.props.history.push('/controls/post_control_note_detail/' + row.postControlDocuments[0].postControlNote.noteId);
	};

	onPostInfoPreviewButtonClick = async (row) => {
		if (row.postControlDocuments) {
			let documents = await getPostControlDocuments(row.id)
			const { setFiltersData } = this.props;
			setFiltersData({ filter: this.state.tabs[this.state.selectedTab].filters, tableName: this.state.documentTitle });
			const { setQuickSearchData } = this.props;
			setQuickSearchData({quickSearch: this.state.tabs[this.state.selectedTab].quickSearch, tableName: this.state.documentTitle, tab: this.state.selectedTab});
			this.showPopup('Dokumenty pokontrolne',
				ControlFunctions.displayInfosListTab(documents, row.number, row.id,'my_controls', () => {
					this.setState({
						record: row,
						isUploadDocsWindowVisible: true,
						showPopup: false,
						docType: getPostControlDocType(documents)
					});
				}), 'notify')
		} else {
			this.showPopup('Komunikat', 'Kontrola nie ma jeszcze dokumentu pokontrolnego.', 'notify')
		}
	};

	onFollowUpButtonClick = (row) => {
		if (row.followUp) {
			this.showPopup('Monitorowanie zaleceń', this.displayFollowUpTab(row), 'custom', null, 3)
		} else {
			this.showPopup('Komunikat', PropertyBucket.getNoFollowUpMessage(), 'notify')
		}
	};

	onRestoreControlButtonClick = (row) => {
		this.showPopup('Komunikat', PropertyBucket.restoreControlConfirmationMessage(row.number), 'confirm', () => {
			this.restoreControl(row)
		})
	};

	restoreControl = (row) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let controlId = row.id;
		let url = PropertyBucket.getChangeControlStatus(controlId);
		let controlDto = new ControlDto();
		controlDto.controlId = controlId;
		controlDto.controlStatus = 1;


		let callPromise = httpService.getServicePromise(url, 'PUT', controlDto);


		callPromise.then(
			function (message) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.restoreControlMessage(), 'notify', () => {
					_this.props.history.push(`/my_controls/active?number=${row.number}`)
				})
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.tabs[this.state.selectedTab].filters.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	onRemarksButtonClick = async(row) => {
		let documents = await getPostControlDocuments(row.id)
		const objectionExists = documents && documents[0]?.postControlInfo?.objection;
		if(objectionExists)	{
			this.setState({
				showRemarksDetail: true,
				documents: documents,
				record: row,
				showPopup: false
			});
		}
		else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlRemarksMessage(), 'notify')
		}
	};

	handlePageChange(page, size) {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(page);
		newState.tabs[this.state.selectedTab].tablePageSize = size;
		this.setState(newState);
		
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, size, this.state.selectedTab === tabs[1]);
	}

	handleFilterChange(filters) {
		this.state.tabs[this.state.selectedTab].filters.forEach((filterField, id) => {
			if (filterField.filterValue !== filters[id].filterValue) {
				this.setState({ filterChangeOnField: filters[id] });
			}
		});

		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].filters = filters;
		this.setState(newState);

		this.props.history.push('/my_controls/done');

		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter: filters, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1], () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].quickSearch = search;
		this.setState(newState);

		this.props.history.push('/my_controls/done');

		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: search, tableName: this.state.documentTitle, tab: this.state.selectedTab});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, search, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1], focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		let orderColumn = this.state.columns[column] ? this.state.columns[column].field : '';

		if (!order) {
			orderColumn = 'number';
			order = 'asc';
			column = this.state.columns.findIndex(col => col.field === 'number');
		}

		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].orderById = column;
		newState.tabs[this.state.selectedTab].orderBy = orderColumn;
		newState.tabs[this.state.selectedTab].orderDirection = order;
		this.setState(newState);

		this.props.history.push('/my_controls/done');

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(newState.tabs[this.state.selectedTab].filters), [orderColumn, order], newState.tabs[this.state.selectedTab].programSearch, newState.tabs[this.state.selectedTab].quickSearch, newState.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);
	}

	handleTabChange(tab) {
		const newColumns = this.getColumnsForTab(tab);
		this.setState({selectedTab: tab, columns: newColumns});

		this.props.history.push(`/my_controls/done${this.state.tabs[tab].page > 0 ? `/${this.state.tabs[tab].page + 1}` : ''}`);
		
		const {fetchControlData, setTabData} = this.props;
		setTabData({quickSearch: this.state.tabs[tab].quickSearch, filter: this.state.tabs[tab].filters, tableName: this.state.documentTitle, tab: tab});
		fetchControlData(this.state.tabs[tab].page, ControlFunctions.getFilterParam(this.state.tabs[tab].filters), [this.state.tabs[tab].orderBy, this.state.tabs[tab].orderDirection], this.state.tabs[tab].programSearch, this.state.tabs[tab].quickSearch, this.state.tabs[tab].tablePageSize, tab === tabs[1]);
	}

	onCompleteChange(control) {
		if (!control.completed) {
			this.setState({
				controlToComplete: control,
				selectedControlResult: null
			});
			this.showPopup(
				'Komunikat',
				this.renderControlResultSelection(control),
				'custom'
			);
		} else {
			// Jeśli przenosimy z powrotem do Zrealizowane
			this.showPopup(
				'Komunikat',
				<div id='popUpNotification'>
					<div className='new-line'>Czynność ta spowoduje przeniesienie kontroli do zakładki: Zrealizowane.</div>
					<div className='btn_group'>
						<button className='btn save-btn' onClick={() => this.handleCompleteChange(this, control, null)}>
							OK
						</button>
						&nbsp;
						<button className='btn cancel-btn' onClick={this.handleClosePopUp}>
							Anuluj
						</button>
					</div>
				</div>,
				'custom'
			);
		}
	}

	renderControlResultSelection(control) {
		const controlResultOptions = [
			{ value: ControlResult.NO_RESERVATIONS, label: ControlResultLabels[ControlResult.NO_RESERVATIONS] },
			{ value: ControlResult.MINOR_RESERVATIONS, label: ControlResultLabels[ControlResult.MINOR_RESERVATIONS] },
			{ value: ControlResult.MAJOR_RESERVATIONS, label: ControlResultLabels[ControlResult.MAJOR_RESERVATIONS] },
			{ value: ControlResult.CANCELLED, label: ControlResultLabels[ControlResult.CANCELLED] }
		];

		return (
			<div id='popUpNotification'>
				<div className='new-line'>Czynność ta spowoduje przeniesienie kontroli do zakładki: Zakończone.</div>
				<div style={{ marginTop: '20px', marginBottom: '80px' }}>
					<SelectCustom
						values={this.state.selectedControlResult ? [this.state.selectedControlResult] : []}
						labelField='label'
						placeholder='Wybierz wynik kontroli'
						valueField='value'
						options={controlResultOptions}
						onChange={(values) => {
							this.setState({ selectedControlResult: values[0] }, () => {
								this.showPopup(
									'Komunikat',
									this.renderControlResultSelection(control),
									'custom'
								);
							});
						}}
						id='controlResultSelectId'
						dropdownId='controlResultDropdownId'
						label='Wynik kontroli'
						labelClassName='mt-3'
					/>
				</div>
				<div className='btn_group'>
					<button
						className='btn save-btn'
						onClick={() => this.handleCompleteChange(this, control, this.state.selectedControlResult?.value)}
						disabled={!this.state.selectedControlResult}
					>
						OK
					</button>
					&nbsp;
					<button className='btn cancel-btn' onClick={this.handleClosePopUp}>
						Anuluj
					</button>
				</div>
			</div>
		);
	}

	handleCompleteChange = (_this, control, controlResult) => {
		this.isWaitingOnOff(true);
		let controlId = control.id;
		let url = PropertyBucket.getChangeControlCompleteStatus(controlId);

		let payload = {
			status: !control.completed
		};

		if (!control.completed && (!!controlResult || controlResult === ControlResult.NO_RESERVATIONS)) {
			payload.internalControlResult = controlResult;
		}

		let callPromise = httpService.getServicePromise(url, 'POST', payload);

		callPromise.then(
			function () {
				const newState = cloneDeep(_this.state);
				newState.tabs[_this.state.selectedTab].page = parseInt(0);
				newState.tabs[_this.state.selectedTab].tablePageSize = 10;
				newState.tabs[_this.state.selectedTab].quickSearch = "";
				newState.tabs[_this.state.selectedTab].filters = [];
				newState.tabs[_this.state.selectedTab].orderBy = "";
				newState.tabs[_this.state.selectedTab].orderById = "";
				newState.tabs[_this.state.selectedTab].orderDirection = "";
				newState.selectedControlResult = null;
				newState.controlToComplete = null;
				_this.setState(newState);

				const isTabForCompleted = _this.state.selectedTab === tabs[1];

				const {fetchControlData} = _this.props;
				fetchControlData(0, "", ["", ""], newState.tabs[_this.state.selectedTab].programSearch, "", 10, isTabForCompleted);
				
				_this.handleClosePopUp();
				_this.isWaitingOnOff(false);
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	
	addedCheckboxesForControls = (controls) => controls.map(c => ({...c, completed: (<Checkbox key={c.id} checked={c.completed} onChange={() => this.onCompleteChange(c)}/>)}));

	get isRestoreDisabled() {
		return this.state.selectedTab === tabs[1];
	}

	render() {
		const { roleDetails } = this.props.userData.user;
		let userRole = roleDetails.role;
		let loadedControlsData;
		loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.doneControls;
		loadedControlsData = this.addedCheckboxesForControls(loadedControlsData)
		let loadedProgsData;
		userRole === 'SA' ? loadedProgsData = store.getState().programs.programs : loadedProgsData = null;
		let table;
		let dropdown;
		let popUp;
		const controlNr = new URLSearchParams(this.props.history.location.search).get('number');
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.handleClosePopUp}
			                size={this.state.popUp.size}
			/>) : null;

		if (this.props.controls && this.props.controls.isDoneControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={ControlFunctions.getColumnsWithDefaultFilterValues(this.state.columns, this.state.tabs[this.state.selectedTab].filters)}
					data={loadedControlsData}
					orderBy={this.state.tabs[this.state.selectedTab].orderById}
					orderDirection={this.state.tabs[this.state.selectedTab].orderDirection}
					count={totalElements}
					page={this.state.tabs[this.state.selectedTab].page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>{rowData.postControlDocuments ? 'Podgląd listy' : 'Edycja listy'}<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'description',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Dokumenty pokontrolne<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onPostInfoPreviewButtonClick(rowData);
							},
						}),
						rowData => ({
							icon: 'message',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zastrzeżenia<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRemarksButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'library_add_check',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Monitorowanie zaleceń<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onFollowUpButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: 'Pliki',
							onClick: async (event, rowData) => {
								let documents = await getPostControlDocuments(rowData.id)
								this.setState({endsControlWithAfterControlNote : endsControlWithAfterControlNote(documents)})
								this.setState({showDocumentsControl: rowData});
							}
						}),
						rowData => ({
							icon: 'restore_page',//sync, restore, replay
							disabled: this.isRestoreDisabled,
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Wznów kontrolę<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRestoreControlButtonClick(rowData);
							}
						}),
					]}
					initialPage={controlNr ?
					getTablePageBaseOnControlNumber({
						controlNr,
						pageSize: 10, // initial PageSize currently is always 10
						list: loadedControlsData,
					}) :
					getTablePageBaseOnPageNumber(
						this.props.match.params.pageNumber,
						10, // initial PageSize currently is always 10
						loadedControlsData
					)}
					pageSize={this.state.tabs[this.state.selectedTab].tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/my_controls/done/${parseInt(page) + 1}`)
							const newState = cloneDeep(this.state);
							newState.tabs[this.state.selectedTab].page = parseInt(page);
							newState.tabs[this.state.selectedTab].tablePageSize = parseInt(size);
							this.setState(newState);
							
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.tabs[this.state.selectedTab].quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
					isTableForDoneControls={true}
					customTabs={<TableCustomTabs tabs={tabs} onTabChange={(e) => this.handleTabChange(e)} active={this.state.selectedTab}/>}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.tabs[this.state.selectedTab].previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.tabs[this.state.selectedTab].previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsLoadedSelectId'
					dropdownId='programmsLoadedDropdownId'
					label='Programy'
					parentRef={this.programmsLoadedSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search'>
				{popUp}
				{this.state.showRemarksDetail &&<RemarksPopup
													data= {this.state.record}
													documents={this.state.documents}
													closeWindow = {() => this.setState({
														showRemarksDetail: false,
													 })}
													onlyPreview = {true}
												/>}
				{this.state.isUploadDocsWindowVisible && <UploadDocumentsPopup
																isPossibleSendData={false}
																isPossibleChangeDate={this.state.docType === 'INF' ? true : false}
																control={this.state.record}
																showPopup={this.showPopup}
																handleLoading={this.isWaitingOnOff}
																handleClose={() => this.setState({
																	isUploadDocsWindowVisible: false,
																 })}
														 />}
				{control !== null &&
					<Documents
						controlUuid={control.uuid}
						endsWithAfterControlNote={this.state.endsControlWithAfterControlNote}
						excludeFromCurrentControl
						inPopup
						projectUuid={control.project.metadata.uuid}
						withDocumentsList
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<h2 className='mb-5'>Moje kontrole - Zrealizowane</h2>
				{userRole === 'SA' ? dropdown : null}
				<div id='controls_table'>
					{table}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isDoneControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getMyControlsDone();
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}

	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback, 'done')),
		fetchProgsData: () => dispatch(actionsProg.getProgramsData()),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
		setTabData: (tab)=> dispatch(actions.setTabData(tab))
	}
};
export const MyControlDoneProvider = connect(mapStateToProps, mapDispatchToProps)(MyControlDone);
